import './App.css';
import Navbar from './components/Navbar/Navbar';
import Banner from './components/Baner/Banner';
import About from './components/About';
import Skill from './components/Skill/Skill';
import Projects from './components/Projext/Projects';
import Contect from './components/Contact/Contect';
import Footer from './components/Footer';
import { useRef } from 'react';


function App() {
  const aboutRef = useRef();
  const homeRef = useRef();
  const skillRef = useRef();
  const projectRef = useRef();
  const contactRef = useRef();

  return (
    <div className=" from-gray-900/10 to-[#010512] overflow-x-hidden">
      <Navbar homeRef={homeRef} aboutRef={aboutRef} skillRef={skillRef} projectRef={ projectRef} contactRef={contactRef} />
      <Banner homeRef={homeRef} />
      <About aboutRef={aboutRef}/>
      <Skill skillRef={skillRef}/>
      <Projects projectRef={ projectRef}/>
      <Contect contactRef={contactRef}/>
      <Footer/>
    </div>
  );
}

export default App;
